export default __webpack_public_path__ + "static/nrk_video-acb61f6a18aae5b10d35daad5217e101.png";